"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var url = require('url');
var _require = require('../../utils'),
  isObject = _require.isObject;
module.exports = setOAuth2Data;
function setOAuth2Data(data) {
  // Check that we have an access token to use for the request and mix it in.
  if (isObject(data.oauth2) && data.oauth2.accessToken) {
    if ((data.oauth2.tokenType || '').toLowerCase() === 'bearer') {
      data.headers = _objectSpread({
        Authorization: "Bearer ".concat(data.oauth2.accessToken)
      }, data.headers);
    } else {
      // Add the access token to the request query.
      var uri = url.parse(data.url, true);
      uri.query.access_token = data.oauth2.accessToken;
      delete uri.search;

      // Update ajax data headers and url.
      data.url = url.format(uri);
      data.headers = _objectSpread({
        Pragma: 'no-store',
        'Cache-Control': 'no-store'
      }, data.headers);
    }
  }
  return data;
}
//# sourceMappingURL=request.js.map